import "./HeadingBanner.scss"
import { useState, useEffect } from "react";
import { APIGet } from '../../API/APIRequest';
import { Loading } from '../../Utilities/Loading';
import DOMPurify from "dompurify";



export function HeadingBanner({ offerId }) {

    const [selectedTheme, setSelectedTheme] = useState("Theme1")
    const [buttons, setButtons] = useState([{ id: "Theme1", value: "Theme1" }, { id: "Theme2", value: "Theme2" },
    { id: "Theme3", value: "Theme3" }, { id: "Theme4", value: "Theme4" }])

    const [bannerData, setBannerData] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        if (!offerId) return;

        APIGet({
            "controller": "product",
            "action": "getofferbanner",
            "environment": null,
            "identifier": offerId
        }).then((response) => {
            if (response.data?.success) {
                setBannerData(response.data.banner);
            }
        }).catch(() => {
            setBannerData(null);
        });
    }, [offerId]);

    useEffect(() => {
        setImageLoaded(false);
    }, [bannerData?.imageUrl]);

    const title = bannerData?.title || "";
    const description = bannerData?.description ? DOMPurify.sanitize(bannerData.description) : "";
    const imageUrl = bannerData?.imageUrl || "";

    if (!bannerData) return null;

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", gap: "20px", position: "absolute", zIndex:"200"}}>
                {buttons.map((item, index) => {
                    return <button key={index} onClick={() => setSelectedTheme(item.id)}>{item.value}</button>
                })}
            </div>
            <div className="item-container header">
                <div className="heading-banner-wrapper">
                    {selectedTheme === "Theme4" ? (
                        <div className="image-background">
                            <div className="heading-banner-image" style={{ backgroundImage: imageUrl ? `url('${imageUrl}')` : 'none', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                                <div className="sleeve">
                                    {title && <h2>{title}</h2>}
                                    {description && <div className="description" dangerouslySetInnerHTML={{ __html: description }}>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="sleeve">
                            <div className={`${selectedTheme === "Theme1" ? "text-image-left" 
                                : selectedTheme === "Theme2" ?  "text-image-right"
                                : selectedTheme === "Theme3" ? "text-only"
                                            : ''}`}>
                                {selectedTheme !== "Theme3" && imageUrl && (
                                    <div className="heading-banner-image">
                                        {!imageLoaded && <Loading loading={true} class="banner-loader" />}
                                        <img
                                            src={imageUrl}
                                            alt="promo_image"
                                            onLoad={() => setImageLoaded(true)}
                                            style={{ display: imageLoaded ? 'block' : 'none' }}
                                        />
                                    </div>
                                )}
                                <div className="heading-banner-info">
                                    {title && <h2>{title}</h2>}
                                    {description && <div className="description" dangerouslySetInnerHTML={{ __html: description }}>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
     )

}
